//mui
import { Alert, Box, CircularProgress, Snackbar, useTheme } from "@mui/material";

//icons-material
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";

//react
import { useEffect, useState } from "react";

//context
import { useLanguage } from "../../context/LanguageProvider";
import axios from "axios";

const AddFavoriteVideosComponent = ({ sx, addUrl, videoId, getUrl }) => {
    const theme = useTheme();
    const { languageState } = useLanguage();
    const userToken = sessionStorage.getItem("token");
    const [addFavorite, setAddFavorite] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "info",
    });

    const handleFavorite = async () => {
        setLoading(true);
        try {
            const requestOptions = {
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            };
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/api/${addUrl}/${videoId}`,
                {},
                requestOptions,
            );
            if (response?.status === 200) {
                setAddFavorite((prev) => !prev);
                setSnackbar({
                    open: true,
                    message: addFavorite ? "Eliminado de favoritos" : "Añadido a favoritos",
                    severity: "success",
                });
            }
        } catch (error) {
            console.error("Error al actualizar favoritos", error);

            let errorMessage = "Error al actualizar favoritos";
            let severity = "error";

            if (error.response) {
                if (error.response.status === 500) {
                    errorMessage = "Problema de permisos";
                }
            } else if (error.message.includes("Network Error") || error.message.includes("CORS")) {
                errorMessage = "Error de conexión, intente nuevamente";
            }

            setSnackbar({
                open: true,
                message: errorMessage,
                severity,
            });
        } finally {
            setLoading(false);
        }
    };

    const getFavorites = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/${getUrl}`, {
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            const newData = response?.data?.videos;
            if (Array.isArray(newData)) {
                setData(newData);
            }
        } catch (error) {
            console.error("Error al obtener favoritos", error);
        }
    };

    useEffect(() => {
        getFavorites();
    }, []);

    useEffect(() => {
        setAddFavorite(data?.some((favorite) => favorite?.id == videoId));
    }, [data, videoId]);

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <>
            <Box
                onClick={handleFavorite}
                sx={{
                    color: theme.palette.primary.main,
                    ...sx,
                }}
                title={languageState.texts.Player.TitleButtonShowFavorite}
            >
                {loading ? (
                    <CircularProgress size={24} />
                ) : addFavorite ? (
                    <FavoriteIcon sx={{ cursor: "pointer" }} />
                ) : (
                    <FavoriteBorderIcon sx={{ cursor: "pointer" }} />
                )}
            </Box>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                    sx={{
                        width: "100%",
                        backgroundColor: "#455a64",
                        color: "#eceff1",
                        "& .MuiAlert-icon": { display: "none" },
                    }}
                >
                    {snackbar?.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default AddFavoriteVideosComponent;
